import React from 'react';
import { useDispatch } from 'react-redux';

import successImg from 'img/success-img.svg';
import warningImg from 'img/question-img.svg';

import Text from 'components/Text';
import { Button } from 'components/Button';
import { Visibility } from 'components/Visibility';
import { SlideStatusEnum } from 'utils/Slider';
import { OpenSlideSuccessProps } from './interface';

import { Container } from './styles';

export const OpenSlideSuccess: React.FC<OpenSlideSuccessProps> = (props) => {
  const { title, description, titleBold, titleFontSize, statusSlide = SlideStatusEnum.SLIDE_SUCCESS } = props;
  const dispatch = useDispatch();

  const handleOnCloseSlider = () => {
    dispatch({ type: 'SHOW_TITLE' });
    dispatch({ type: 'CLOSE_SLIDER' });
  };

  return (
    <Container>
      <Visibility visible={statusSlide === SlideStatusEnum.SLIDE_SUCCESS}>
        <img src={successImg} alt="success-img" />
      </Visibility>

      <Visibility visible={statusSlide === SlideStatusEnum.SLIDE_WARNING}>
        <img src={warningImg} alt="warning-img" />
      </Visibility>
      <Text
        className={`mt-3 mb-1 color-blue-gray ${titleBold ? 'font-bold' : ''}`}
        size={titleFontSize || 14}
      >
        {title}
      </Text>
      <Text className="color-blue-gray text-center w-100 text-wrap-normal">
        {description}
      </Text>
      <Button
        onClick={() => handleOnCloseSlider()}
        className="outline mt-3"
        width="auto"
      >
        <Text className="color-primary font-bold px-2">
          Fechar
        </Text>
      </Button>
    </Container>
  );
};